// src/components/Dashboard/SummaryCards.jsx
import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import {
  People,
  Warning,
  AccountBalance,
  ShowChart,
  AttachMoney,
} from '@mui/icons-material';
import { motion } from 'framer-motion';
// import Sparkline from '../common/Sparkline';

const SummaryCard = ({ title, value, icon: Icon, trend, color }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.3 }}
  >
    <Card>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <Typography color="textSecondary" gutterBottom>
              {title}
            </Typography>
            <Typography variant="h4" component="div">
              {value}
            </Typography>
          </Box>
          <Icon color="primary" />
        </Box>
        {/* {trend && (
          <Box mt={2} height={30}>
            <Sparkline data={trend} />
          </Box>
        )} */}
      </CardContent>
    </Card>
  </motion.div>
);

const SummaryCards = ({ data }) => {
  const { summary } = data;
  
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={2.4}>
        <SummaryCard
          title="Total Customers"
          value={summary.total_customers.toLocaleString()}
          icon={People}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2.4}>
        <SummaryCard
          title="Affected Customers"
          value={summary.affected_customers.toLocaleString()}
          icon={Warning}
          trend={[
            { value: summary.affected_customers * 0.8 },
            { value: summary.affected_customers * 0.9 },
            { value: summary.affected_customers }
          ]}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2.4}>
        <SummaryCard
          title="Total Transactions"
          value={summary.total_transactions}
          icon={AccountBalance}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2.4}>
        <SummaryCard
          title="Total Anomalies"
          value={summary.total_anomalies.toLocaleString()}
          icon={ShowChart}
          trend={[
            { value: summary.total_anomalies * 0.8 },
            { value: summary.total_anomalies * 0.9 },
            { value: summary.total_anomalies }
          ]}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2.4}>
        <SummaryCard
          title="Financial Impact"
          value={summary.financial_impact}
          icon={AttachMoney}
          trend={[
            { value: 20000 },
            { value: 25000 },
            { value: 28467 }
          ]}
        />
      </Grid>
    </Grid>
  );
};

export default SummaryCards;